<template>
  <div>
    <ViewTemplateConfiguration :templateList="templateList" :propsParam="propsParam">
      <div slot="content-buttons">
        <Button
          _key="btnTagCreate"
          title="Tag"
          classIcon="fas fa-plus-circle"
          type="primary"
          size="small"
          :clicked="openCreateModal"
        />
      </div>
    </ViewTemplateConfiguration>

    <Modal title="Tag" :width="500" :height="250" v-if="showModal('plannerTagForm')">
      <TagCreateUpdate module="planner" />
    </Modal>
  </div>
</template>

<script>
import Button from "@/ui/forms/Button";
import Modal from "@/ui/forms/Modal";

import ViewTemplateConfiguration from "@/ui/template/ViewTemplateConfiguration";

import TagCreateUpdate from "@/components/modules/shared/tag/TagCreateUpdate.vue";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "PlannerTagConfig",
  components: { ViewTemplateConfiguration, Modal, Button, TagCreateUpdate },
  data() {
    return {
      templateList: {
        urlGetApi: "/api/v1/shared/tag/get-all",
        urlDeleteAllApi: "/api/v1/shared/tag/delete",
        headerTable: [
          {
            field: "name",
            title: "Nome",
            type: "link",
            iconSearch: true,
            eventName: "tagUpdate",
          },
          {
            field: "colorHtml",
            type: "html",
            styleBody: "width: 200px;",
          },
        ],
      },
      propsParam: {
        any: "planner",
      },
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    openCreateModal() {
      this.openModal("plannerTagForm");
      this.addEvent({ name: "tagCreate" });
      this.removeLoading(["btnTagCreate"]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name === "tagUpdate") this.openModal("plannerTagForm");
      },
      deep: true,
    },
  },
};
</script>

